import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRoleInfo } from '../../components/Shared/UserRoleInfo';

const tabs = [
  { id: 'documents', name: 'Documentos', icon: 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z' },
  { id: 'users', name: 'Usuários', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
  { id: 'teams', name: 'Equipes', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
  { id: 'permissions', name: 'Permissões', icon: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' },
  { id: 'notifications', name: 'Notificações', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' },
  { id: 'security', name: 'Segurança', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
  { id: 'integrations', name: 'Integrações', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
  { id: 'services', name: 'Serviços', icon: 'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01' },
  { id: 'ai', name: 'Inteligência Artificial', icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
];

export const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [selectedTab, setSelectedTab] = useState(0);

  // Verifica se o usuário é administrador
  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex-1">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
                <p className="mt-1 text-sm text-gray-500">
                  Gerencie as configurações do sistema e permissões de usuários.
                </p>
              </div>

              {/* Informações do usuário */}
              <div className="mb-8">
                <UserRoleInfo />
              </div>

              {/* Tabs de configurações */}
              <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8">
                  {tabs.map((tab, index) => (
                    <button
                      key={tab.id}
                      onClick={() => setSelectedTab(index)}
                      className={`py-2 px-1 border-b-2 font-medium text-sm ${
                        selectedTab === index
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <div className="flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 mr-2"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d={tab.icon}
                          />
                        </svg>
                        {tab.name}
                      </div>
                    </button>
                  ))}
                </nav>
              </div>

              {/* Conteúdo das tabs */}
              <div className="mt-6">
                {selectedTab === 0 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Documentos</h3>
                    <p className="text-gray-600">Configurações relacionadas ao gerenciamento de documentos.</p>
                  </div>
                )}
                {selectedTab === 1 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Usuários</h3>
                    <p className="text-gray-600">Gerencie usuários e suas permissões no sistema.</p>
                  </div>
                )}
                {selectedTab === 2 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Equipes</h3>
                    <p className="text-gray-600">Configure equipes e hierarquias organizacionais.</p>
                  </div>
                )}
                {selectedTab === 3 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Permissões</h3>
                    <p className="text-gray-600">Defina permissões e roles do sistema.</p>
                  </div>
                )}
                {selectedTab === 4 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Notificações</h3>
                    <p className="text-gray-600">Configure notificações e alertas do sistema.</p>
                  </div>
                )}
                {selectedTab === 5 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Segurança</h3>
                    <p className="text-gray-600">Configure políticas de segurança e autenticação.</p>
                  </div>
                )}
                {selectedTab === 6 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Integrações</h3>
                    <p className="text-gray-600">Configure integrações com sistemas externos.</p>
                  </div>
                )}
                {selectedTab === 7 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de Serviços</h3>
                    <p className="text-gray-600">Configure serviços e APIs do sistema.</p>
                  </div>
                )}
                {selectedTab === 8 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">Configurações de IA</h3>
                    <p className="text-gray-600">Configure modelos de IA e processamento de linguagem natural.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 